import React, { Component } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { Collapsible, MenuRoute } from '../../routes/menuRoutes'
import { RootState } from '../../store'
import Icon from '../Icon'
import SubMenuItem from '../SubMenuItem'
import { toggleFolded } from './CollapsibleMenu.slice'

interface Props {
  collapsible: Collapsible
  onRoute: () => void
}

type CombinedProps = Props & ConnectedProps<typeof connector>

class CollapsibleMenu extends Component<CombinedProps> {
  menuItem (sub: MenuRoute) {
    return (
      <SubMenuItem
      text={sub.text}
      icon={sub.icon}
      to={sub.to}
      onRoute={this.props.onRoute}
      key={sub.to} />
    )
  }

  menuItems (subsidiaries: MenuRoute[]) {
    return this.props.folded && subsidiaries.map(sub => this.menuItem(sub))
  }

  render () {
    const { collapsible } = this.props
    return (
      <div key={collapsible.text}>
        <div className='flex cursor-pointer p-1 select-none' onClick={this.props.toggleFolded}>
          <Icon name='route' size='medium' color='white' />
          <h3 className='text-white ml-3'>{collapsible.text}</h3>
        </div>
        <div className='pl-5'>
          {this.menuItems(collapsible.subsidiaries)}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state: RootState) => {
  return {
    folded: state.collapsibleMenu.folded
  }
}

const mapDispatchToProps = {
  toggleFolded
}

const connector = connect(mapStateToProps, mapDispatchToProps)
export default connector(CollapsibleMenu)
